module.exports = __webpack_public_path__ + "img/porte_cle.649779c5.png";